import {
  BoxProps,
  boxRestyleFunctions,
  createRestyleComponent,
} from "@shopify/restyle";
import {
  ScrollView as NativeScrollView,
  ScrollViewProps as NativeScrollViewProps,
} from "react-native";

import { Theme } from "../../../theme/restyle/theme";

export type ScrollViewProps = BoxProps<Theme> & NativeScrollViewProps;

export const RestyleScrollView = createRestyleComponent<ScrollViewProps, Theme>(
  boxRestyleFunctions,
  NativeScrollView
);
